import React from "react";
import Navbar from "../assets/Navbar/Navbar";
import Footer from "../assets/Footer/Footer";
import '../pages/Work.css';
import { useNavigate } from "react-router-dom";
import grouplogoimg from "../assets/Images/OctalumeLogo.png";
import groupnameimg from "../assets/Images/studioname.png";


const Work = () => {
    const navigate = useNavigate();

    const cardswork = [
        // {
        //     title: "Group Logo",
        //     description: "Process of making logo",
        //     image: grouplogoimg,
        //     path: '/grouplogo/'
        // },

        // {
        //     title: "Group Name",
        //     description: "Process of choosing our name",
        //     image: groupnameimg,
        //     path: "/groupname/"
        // },

        // {
        //     title: "Group Artworks & Product",
        //     description: "",
        //     image: ".",
        //     path: "/groupartworks/"
        // },

        // {
        //     title: "Process for this Portfolio",
        //     description: "",
        //     image: ".",
        //     path: "/processportfolio/"
        // },

        // {
        //     title: "Client Project",
        //     description: "",
        //     image: ".",
        //     path: "/workclient/"
        // },
        
        // {
        //     title: "Interview",
        //     description: "",
        //     image: ".",
        //     path: "//"
        // },

        // {
        //     title: "Videolab Observation",
        //     description: "",
        //     image: ".",
        //     path: "/workvideolab/"
        // },

        // {
        //     title: "Poster's",
        //     description: "",
        //     image: ".",
        //     path: "/workposters/"
        // },

        // {
        //     title: "Career Day",
        //     description: "",
        //     image: ".",
        //     path: "/workcareer/"
        // },

        {
            title: "Mascot's For Client",
            description: "",
            // image: ,
            path: '/mascot'
        },

        {
            title: "Homepage 3D tracking cursor",
            description: "",
            // image: groupnameimg,
            path: "/3d"
        },

        
    ];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Work In Progress</h1>
                <p>Few projects/ task I am planning and doing for future portfolio assets</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-card-container">
                    {cardswork.map(({ title, description, image, path }, index) => (
                        <div 
                            key={index} 
                            className="card-work" 
                            onClick={() => navigate(path)} // Navigate to respective page
                        >
                            <img src={image} alt={title} className="card-work-image" />
                            <h3 className="card-work-title">{title}</h3>
                            <p className="card-work-description">{description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Work